export { default as LeadCapture } from './LeadCapture';
